import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const FraternitySororities = (props) => {
	const fraternitySororities = props.data.fraternity_sororities;

	if (!_.isArray(fraternitySororities) || _.isEmpty(fraternitySororities)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(fraternitySororities, ({ fs_fraternity_sorority: fraternitySorority }) => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>{fraternitySorority}</li>
			))}
		</ul>
	);
};

FraternitySororities.propTypes = {
	data: PropTypes.object.isRequired,
};

export default FraternitySororities;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/fraternity-sororities.js